import React from 'react'
import { useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { TextWrap } from "../../util/showmore";
import { getCallTransferAgent } from "./api";
import { CallControls } from "./CallControls";
import { mergeAgentToConference } from "./CallService";
import { getAgentPhone, getName } from "./helpers";
import { LiveCallMinimized } from "./LiveCallMinimized";
import { Timer } from "./Timer";

export function MergeCall(props) {
  const { callFlow } = props;
  const dispatch = useDispatch();
  const legCAgent = getCallTransferAgent();

  return (
    <>
      <div className="tmodal tmodal-dialog-scrollable call-ticker-dialog-sec">
        <div className="tmodal-content">
          <LiveCallMinimized {...props} disableSymbols={true} />

          <div className="initiated-conference-title-sec">
            <div className="head-title-label">Call Transfer</div>
            <div className="voice-indicator">
              <img
                alt=""
                className="voice-indicator-icon"
                src={toAbsoluteUrl("/media/sr/icons/voice-indicator-green.svg")}
              />
            </div>
          </div>
          <div className="py-7 px-5">
            <div className="live-call-section">
              <div className="merge-call-sec">
                <div className="user-photo user-status ">
                  <div className="user-photo-icon status-available">
                    {getName(legCAgent)[0].toUpperCase()}
                  </div>
                  <div className="user-status-indicator"></div>
                </div>
                <div className="call-timer">
                  <Timer disableSymbols={true} />
                </div>
                <div className="inc-usr-name">
                  <TextWrap text={getName(legCAgent)} max={17} />
                </div>
                <div className="inc-usr-number">
                  <TextWrap text={getAgentPhone(legCAgent)} max={17} />
                </div>
                <div className="merge-call-icon">
                  <a
                    className="w-link"
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      mergeAgentToConference(callFlow, legCAgent, dispatch);
                    }}
                  >
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/sr/icons/merge-call.svg")}
                    />
                  </a>
                </div>
                <div className="merge-call-text">
                  <a
                    className="w-link"
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      mergeAgentToConference(callFlow, legCAgent, dispatch);
                    }}
                  >
                    Merge Calls
                  </a>
                </div>
                <CallControls {...props} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
